import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useUserStatistics from '../../../../hooks/web3/vault/useUserStatistics';

const TotalBalance: React.FC = () => {
    const { userStatistics } = useUserStatistics();

    const userStatsWithoutTotal = userStatistics
        ? Object.entries(userStatistics.spools).filter(
              ([_, { userUnderlying }]) => userUnderlying !== 0
          )
        : [];

    return (
        <Detail
            title={
                <>
                    <span>Your Total Balance in Spool</span>
                    <InfoPopUp>
                        <span>Your Total Balance in Spool:</span>
                        {userStatsWithoutTotal.length ? (
                            userStatsWithoutTotal.map(
                                ([spoolId, { userUnderlying, spoolDetails }]) => (
                                    <div key={spoolId} className='mt'>
                                        <span>{spoolDetails?.spoolName || 'Spool'}</span>
                                        <strong className='block'>
                                            {formatUSD(userUnderlying || 0)}{' '}
                                            {spoolDetails?.underlying?.symbol || 'Asset'}
                                        </strong>
                                    </div>
                                )
                            )
                        ) : (
                            <strong className='block'>N/A</strong>
                        )}
                    </InfoPopUp>
                </>
            }
            value={`$${formatUSD(userStatistics?.total?.userUnderlying || 0)}`}
        />
    );
};

export default TotalBalance;
